import { z } from 'zod';
import { ProductIdSchema } from './ProductId';
import { ProductTypeSchema } from './ProductType';
import { DepositTakingBankDetailsSchema } from './DepositTakingBankDetails';
import { PreContractualDocumentsSchema } from './PreContractualDocuments';
import { ConditionsSchema } from './Conditions';

export const ProductSchema = z.object({
  id: ProductIdSchema,
  product_type: ProductTypeSchema,
  marketed_as_product_type: ProductTypeSchema.optional(),
  currency: z.string(),
  term: z
    .object({
      unit: z.enum(['days', 'weeks', 'months', 'years']).nullable().optional(),
      period: z.number().nullable().optional(),
    })
    .nullable()
    .optional()
    .transform((value) => {
      if (!value || !value.period || !value.unit) {
        return null;
      }
      return {
        unit: value.unit,
        period: value.period,
      };
    }),
  interest_rates: z.object({
    interest_rate_nominal: z.string(),
    interest_rate_effective: z.string(),
    headline_interest_rate: z.string().optional(),
    upcoming_rates: z.array(
      z.object({
        interest_rate_effective: z.string(),
      }),
    ),
  }),
  conditions: ConditionsSchema,
  deposit_taking_bank: DepositTakingBankDetailsSchema,
  pre_contractual_documents: PreContractualDocumentsSchema,
  display: z.object({
    labels: z.array(z.string()),
  }),
});

export type Product = z.infer<typeof ProductSchema> & { compliance?: any };
